import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import styles from './ErrorBoundaryPage.module.css';

export function ErrorBoundaryPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : null;
  const statusText = isRouteErrorResponse(error) ? error.statusText : null;
  const message = error instanceof Error ? error.message : String(error ?? 'Unknown error');

  return (
    <section className={`${styles.section} container-wide`}>
      <p className={styles.eyebrow}>{status ? `${status} · ${statusText ?? 'Error'}` : 'Error'}</p>
      <h1 className={styles.headline}>
        Something failed to render.
      </h1>
      <p className={styles.body}>
        Either the published data export is temporarily unavailable, or the page hit an unexpected error during
        rendering. The error is reproduced below for transparency.
      </p>
      <pre className={styles.error}>{message}</pre>
      <Link to="/" className={styles.cta}>Return to the leaderboard →</Link>
    </section>
  );
}
